<template>
  <div v-on-clickaway="closeModal" class="relative flex flex-col justify-center items-center w-full md:w-5/12 rounded-2xl bg-white py-6 px-12">
    <div class="h-32 w-32">
        <img v-if="!includesVideo" :onerror="`this.onerror=null; this.src='${IMAGE_PLACEHOLDER}'`" :src="item.url" :alt="item.name" class="w-full h-full object-cover rounded-xl"/>
        <video
            ref="video"
            v-else
            class="w-full h-full object-cover rounded-xl"
            autoplay
            muted
            loop
            :poster="CHARGING_VIDEO"
        >
            <source :src="item.url" :type="item.mime_type && item.mime_type !== 'video/quicktime' ? item.mime_type : 'video/mp4'">
            Your browser does not support the video tag.
        </video>
    </div>
    <div class="w-full pt-2 pb-4 flex items-center justify-center">
        <span v-if="item" class="text-md text-yank">{{item.name}}</span>
    </div>
    <div class="max-h-48 overflow-y-auto w-full mb-6">
        <div class="pb-0 w-full" :class="removePadding(index, folderLevels) ? 'pb-0' : 'pb-5'" v-for="(level, index) in folderLevels" :key="index">
            <div :id="index === folderLevels.length - 1 ? 'last' : 'actual' + index" v-if="level.folders.length > 0">
                <span :class="level.actual ? 'text-black' : 'text-gray-400'" class="font-semibold pl-3">{{ index === 0 ? 'Choose a folder' : 'Subfolder' }}</span>
                <v-select
                    label="name"
                    class="dropdown pt-2"
                    :style="level.actual === null ? '--vs-controls-color: #bdbdbd;--vs-selected-color: #bdbdbd;' : '--vs-controls-color: #6B7E99;--vs-selected-color: #181F36;'" 
                    :components="{Deselect}" 
                    :appendToBody="true"
                    :value="level.actual !== null ? level.actual : {name: 'Choose folder', id: null}" 
                    :options="level.folders"
                    @open="disableScroll"
                    @close="enableScroll"
                    @input="updateFolders"
                ></v-select>
            </div>
        </div>
    </div>
    <div class="flex items-center justify-between w-full">
        <button @click="closeModal" class="w-1/2 py-4 text-sm border-gray border rounded-lg mr-4" type="button">Cancel</button>
        <button @click="move" class="w-1/2 border py-4 text-sm bg-aquamarine border-aquamarine rounded-lg text-white" type="submit">Move</button> 
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import {mixin as clickaway} from 'vue-clickaway'
import { IMAGE_PLACEHOLDER, CHARGING_VIDEO } from '@/utils/constants';

export default {
    name:"MoveItemModal",

    mixins: [clickaway],  

    props:{
        item:{
            type: Object,
            default: null
        },
        flash: Object,
    },

    data() {
        return {
            IMAGE_PLACEHOLDER,
            CHARGING_VIDEO,
            folderLevels: [],
            Deselect: {
                render: createElement => createElement('span', ''),
            },
        }
    },

    computed: {
        includesVideo() {
            return this.item && this.item.mime_type.includes('video');
        },

        actualFolder() {
            const levelsWithFolderSelected = this.folderLevels.filter(level => level.actual != null);
            return levelsWithFolderSelected[levelsWithFolderSelected.length - 1].actual;
        }
    },

    async mounted() {
        await this.chargeLevels(this.item && this.item.folder_id ? this.item.folder_id : 0);
    },
    
    methods: {
        removePadding(index, folderLevels) {
            if (index === folderLevels.length - 1) {
                return true;
            }

            const nextLevel = folderLevels[index + 1];
            if(nextLevel) {
                return nextLevel.folders.length === 0;
            }

            return false;
        },

        scrollToLast() {
            setTimeout(() => {
                const el = document.getElementById("last");
                if(el) {
                    el.scrollIntoView({behavior: 'smooth'});
                }
            }, 100);
        },

        async chargeLevels(folderId) {
            try {
                const response = await axios.get(this.$route('church-media.folders.getLevelsById', folderId), {
                    redirect: false,
                })
                this.folderLevels = [... response.data.levels];
                this.scrollToLast();
            } catch (ex) {
                this.flash.error = 'Only folders owners can rename them';
            }
        },

        disableScroll() {
            document.documentElement.style.overflow = 'hidden';

            setTimeout(() => {
                document.getElementsByClassName('vs__dropdown-menu')[0].style.maxHeight = '200px';
            }, 10);
        },

        enableScroll() {
            document.documentElement.style.overflow = 'auto';
        },

        closeModal() {
            this.$emit('closeModal')
        },
        async updateFolders(folder) {
            await this.chargeLevels(folder.id !== null ? folder.id : 0);
        }, 
        move() {
            const folderId = this.actualFolder.id;
            if(this.item.folder_id === null) {
                this.$emit('removeFromRoot', this.item);
            }
            this.$inertia.put(this.$route('church-media.items.move', this.item.id), {'folder_id': folderId}, {preserveScroll: true});
            this.closeModal();
        },
    },

    watch: {
        flash: {
            handler(flash) {
                if (flash.success && flash.success !== '') {
                    this.$toast.success(flash.success);
                }
                if (flash.error && flash.error !== '') {
                    this.$toast.error(flash.error);
                    this.flash.error = '';
                }
            },
            deep: true,
        },
        
    }
}
</script>
<style scoped>
 .dropdown {
    --vs-border-color: #E9E9E9;
    --vs-actions-padding: 20px 20px 18px 0px;
    --vs-controls-size: 0.9;
    --vs-search-input-color: #eeeeee;
    --vs-dropdown-option--active-color: #eeeeee;
    --vs-border-radius: 9px;
    --vs-selected-border-width: 10px;
}
</style>